module.exports = __webpack_public_path__ + "img/close.b1e62517.svg";